export interface StockSaturationDTO {
  daysForSaturation: number;
}

export const stockSaturationDTOMapper = (data: any): StockSaturationDTO => ({
  daysForSaturation: data.daysForSaturation
});
